import { useCallback, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { LuBuilding2 } from 'react-icons/lu';
import { IStageStatusPair, getAllBusinessDefinition } from 'wisestep-api';
import { WsColors, WsSelect, WsSelectObj } from 'wisestep-base';

import WsFilterProps from '../models/WsFilterProps';

import WsAccordion from './WsAccordion';
export interface WsSelectBusinessDefinition {
  label: string;
  value: IStageStatusPair[];
}

export interface WsSelectBusinessDefinitionNew {
  businessDefinitionName: string;
  createdBy?: string;
  createdOn?: string;
  id?: string;
  isArchive?: boolean;
  jobOption?: string;
  modifiedBy?: string;
  modifiedOn?: string;
  stageStatusData: IStageStatusPair[];
  workspaceId?: string;
}
const BusinessDefinitionFilter = ({ name, showAccordionIcon = false }: WsFilterProps) => {
  const [dropDownOption, setDropDownOption] = useState<WsSelectObj[]>();

  const defaultOptions: WsSelectObj[] = [
    {
      label: '--No Business Definitions Available. Please Configure from Settings Page--',
      value: '[]',
    },
  ];
  const methods = useForm();
  const fetchAllBusinessDefinition = useCallback(async () => {
    const response = await getAllBusinessDefinition();
    if (response.data.length > 0) {
      const newOptions = response.data.map((element) => {
        const optionObject: WsSelectBusinessDefinitionNew = {
          businessDefinitionName: element.businessDefinitionName,
          jobOption: element.jobOption,
          stageStatusData: element.stageStatusData.flatMap((ssd) =>
            ssd.selectedStatuses.map((ss) => ({
              applicationStage: ssd.stage,
              applicationState: ss,
            }))
          ),
        };

        return {
          label: optionObject.businessDefinitionName,
          value: JSON.stringify(optionObject),
        };
      });

      setDropDownOption(newOptions);
    }

    methods.reset();
  }, [methods]);

  useEffect(() => {
    fetchAllBusinessDefinition();
  }, [fetchAllBusinessDefinition]);

  return (
    <WsAccordion
      title="Business Definition"
      {...(showAccordionIcon && { startIcon: <LuBuilding2 color={WsColors.TertiaryShades800} /> })}
    >
      <WsSelect
        name={name}
        selectArray={dropDownOption ?? defaultOptions}
        placeholder={
          dropDownOption
            ? 'Business Definition'
            : '--No Business Definitions Available. Please Configure from Settings Page--'
        }
        disabled={dropDownOption ? false : true}
      />
    </WsAccordion>
  );
};

export default BusinessDefinitionFilter;
